module.exports = __webpack_public_path__ + "media/about/BloodDriveBus-64034c44.jpg";